import React, { useId } from 'react';
import * as Styled from './MTextBlockInteractive.styles';
import type { MTextBlockInteractiveProps } from './MTextBlockInteractive.types';
import { ATextInteractive } from '../../atoms/ATextInteractive';
import { ATextInteractiveSize } from '../../atoms/ATextInteractive/ATextInteractive.types';
import { ABody } from '../../atoms/ABody';
import { ABodySize, ABodyColor } from '../../atoms/ABody/ABody.types';

const COMPONENT_NAME = 'm-web-ui-kit-MTextBlockInteractive';
const TEST_ID = 'web-ui-kit-MTextBlockInteractive';

function MTextBlockInteractive({ aTextInteractive, aBody, ...rest }: MTextBlockInteractiveProps) {
  const generatedId = useId();
  const hasLabel = Boolean(aTextInteractive?.text?.trim());
  const hasBody = hasValidBody(aBody);
  const bodyId = hasBody ? aBody.id ?? `${COMPONENT_NAME}-aBody-${generatedId}` : undefined;
  const describedByIds = [aTextInteractive?.['aria-describedby'], bodyId].filter(Boolean);
  const describedBy = describedByIds.length ? describedByIds.join(' ') : undefined;

  return (
    <Styled.Wrapper {...rest} data-component-name={COMPONENT_NAME} data-testid={TEST_ID}>
      {hasLabel && (
        <ATextInteractive
          {...aTextInteractive}
          size={aTextInteractive.size ?? ATextInteractiveSize.S}
          aria-describedby={describedBy}
        />
      )}
      {hasBody && (
        <ABody {...aBody} id={bodyId} size={aBody.size ?? ABodySize.XS} color={aBody.color ?? ABodyColor.Alternate} />
      )}
    </Styled.Wrapper>
  );
}

type ABodyWithText = NonNullable<MTextBlockInteractiveProps['aBody']> & { bodyText: string };
function hasValidBody(aBody: MTextBlockInteractiveProps['aBody']): aBody is ABodyWithText {
  return Boolean(aBody?.bodyText?.trim());
}

export { MTextBlockInteractive, TEST_ID as M_TEXT_BLOCK_INTERACTIVE_TEST_ID };
export * from './MTextBlockInteractive.types';
